import React, { ReactNode } from "react";

import { cn } from "@/utils/general";

import styles from "./SearchResultsLayout.module.scss";

interface SearchResultsLayoutProps {
  isReversed?: boolean;
  children: [ReactNode, ReactNode]; // [content, sidebar]
}

/**
 * Layout for search results with a main content area and optional sidebar.
 * On mobile, content/sidebar order can be reversed.
 */
const SearchResultsLayout: React.FC<SearchResultsLayoutProps> = ({
  isReversed = false,
  children: [content, sidebar],
}) => {
  const mainOrderClass = isReversed ? styles.order1rev : styles.order1;
  const asideOrderClass = isReversed ? styles.order2rev : styles.order2;

  return (
    <div className={styles.resultsContent}>
      <main className={cn(styles.main, mainOrderClass, sidebar ? "max-w-[800px]" : "")}>
        {content}
      </main>
      <aside className={cn(styles.aside, asideOrderClass)}>{sidebar}</aside>
    </div>
  );
};

export default SearchResultsLayout;
